import { render, staticRenderFns } from "./CekGadai.vue?vue&type=template&id=36f1f1c3&"
import script from "./CekGadai.vue?vue&type=script&lang=js&"
export * from "./CekGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports